import { render, staticRenderFns } from "./ZHshenhe.vue?vue&type=template&id=16cf1958&"
import script from "./ZHshenhe.vue?vue&type=script&lang=js&"
export * from "./ZHshenhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports